module.exports = __webpack_public_path__ + "static/media/female.72e6a978.svg";